module.exports = __webpack_public_path__ + "static/media/WeChat.21df0822.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/WeChat.png
// module id = 174
// module chunks = 0